"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Link } from "@/components/common/Link";
export default function Sponsors() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.75
  });
  const sponsors = [{
    id: 1,
    name: "Beck Automotive",
    logo: "https://rackemjoelivestream.net/wp-content/uploads/2026/01/beck.jpg",
    description: "The Absolute Best Car Service in Franklin, IN"
  }, {
    id: 2,
    name: "Diamond Billiard Products Inc",
    logo: "https://rackemjoelivestream.net/wp-content/uploads/2025/12/diamondbilliards.jpg",
    description: "Serious Pool Tables for Serious Players"
  }, {
    id: 3,
    name: "J&L Billiards",
    logo: "https://rackemjoelivestream.net/wp-content/uploads/2025/12/jlbilliardslogo.jpg",
    description: "Everything You Need To Enjoy The Sport To The Fullest"
  }, {
    id: 4,
    name: "Hoosier Open 9-Ball Tour",
    logo: "https://rackemjoelivestream.net/wp-content/uploads/2025/12/hoosiertourlogo.jpg",
    description: "Fairest 9 Ball Split Bracket"
  }, {
    id: 5,
    name: "Ultimate Pool League Indianpolis Metro",
    logo: "https://rackemjoelivestream.net/wp-content/uploads/2026/01/ultimatepool.jpg",
    description: "This is pool at its best — fast, fierce, and built for the players"
  }];
  return <section className="relative py-24 px-4 bg-background overflow-hidden">
      <div className="container mx-auto max-w-6xl">
        <Card ref={ref} className={`bg-surface border border-border rounded-lg shadow-medium transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="py-12 px-8">
            <h2 className="text-4xl font-display font-bold text-foreground text-center mb-4">
              Our Sponsors
            </h2>
            <p className="text-muted-foreground-dark text-center mb-12 max-w-2xl mx-auto">
              We're grateful for the support of our amazing sponsors who make
              our work possible
            </p>

            <Carousel opts={{
            align: "start",
            loop: true
          }} className="w-full max-w-5xl mx-auto">
              <CarouselContent>
                {sponsors.map((sponsor, i) => <CarouselItem key={sponsor.id} data-index={i} className="md:basis-1/2 lg:basis-1/3">
                    <div className="p-4 group">
                      <div className="flex flex-col items-center text-center space-y-4">
                        <div className="relative w-48 h-32 flex items-center justify-center bg-background/50 rounded-lg border border-border/50 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] group-hover:border-primary group-hover:shadow-[0_0_20px_rgba(244,63,51,0.5)] group-hover:scale-105 overflow-hidden p-4">
                          <img src={sponsor.logo} alt={`${sponsor.name} logo`} className="max-w-full max-h-full object-contain" />
                        </div>
                        <div className="overflow-hidden">
                          <h3 className="text-lg font-semibold text-foreground mb-2">
                            {sponsor.name}
                          </h3>
                          <p className="text-sm text-muted-foreground-dark transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:translate-y-0 translate-y-2 opacity-0 group-hover:opacity-100">
                            {sponsor.description}
                          </p>
                        </div>
                      </div>
                    </div>
                  </CarouselItem>)}
              </CarouselContent>
              <CarouselPrevious className="bg-surface border-border hover:bg-surface/80 hover:border-primary -left-4 lg:-left-12" />
              <CarouselNext className="bg-surface border-border hover:bg-surface/80 hover:border-primary -right-4 lg:-right-12" />
            </Carousel>

            <div className="flex justify-center mt-12">
              <Button asChild className="bg-accent hover:bg-accent-hover text-gray-900 px-8 py-3 rounded-md font-semibold transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:shadow-[0_0_20px_rgba(255,119,51,0.6)] hover:scale-105 active:scale-95">
                <Link to="https://www.facebook.com/rackemjoe" className="no-underline">
                  Become a Sponsor
                </Link>
              </Button>
            </div>
          </div>
        </Card>
      </div>
    </section>;
}